import DOMPurify from 'dompurify';

/**
 * Clean HTML from the API before it is rendered with dangerouslySetInnerHTML.
 * Job and client descriptions come from many users and external imports, and
 * a script in any of them would run with the recruiter's session.
 */
export const sanitizeHtml = (html) => DOMPurify.sanitize(html ?? '', { USE_PROFILES: { html: true } });
